import React, { useEffect, useRef, useState } from 'react';
import { Form, Button, Popconfirm, Table, Row, Col, Modal, Select } from 'antd';
import AWS from 'aws-sdk';
import dayjs from 'dayjs';
import { unescapeNested } from '../../../System/Global/unescapeArray';
import Loader from '../../../System/Components/Loader'
import { getRecords } from '../../../System/Api/OPEXAPI';
const config = {
    region:             'eu-west-1',
    accessKeyId:        'AKIA4B4UUQNSSTDHBWHP',
    secretAccessKey:    '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',

}
AWS.config.update(config)

export const FileViewer = ({reference}) => {

    console.log(reference)

    const [ files, setFiles ] = useState([])
    const [ loading, setLoading ] = useState(true)

    useEffect( () => {

        ( async () => {

            if (reference) {
                await loadFiles();
            } else {
                setLoading(false)
            }
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const loadFiles = async () => {
        
        // get upload types if a client

        setLoading(true)

        const sql = `SELECT pods.*, CONCAT(users.firstName, ' ', users.lastName) AS username FROM pods LEFT JOIN users ON users.userKey = pods.userKey WHERE qualityScore >= 4 AND approved = 1 AND crgoRef = ? ORDER BY name ASC`
        const bindings = [reference]
        let _files = await getRecords(sql, bindings)

        // let _files = await get ( 
        //     'pods', 
        //     {'qualityScore >=': 4, approved: "1", crgoRef: reference}, 
        //     [{fieldName: 'name', orderDirection: 'asc'}],
        //     ["pods.*, CONCAT(users.firstName, ' ', users.lastName) AS username"],
        //     [
        //         {
        //             tableName: "users", joinCondition: "users.userKey = pods.userKey"
        //         }
        //     ]
        // )

        _files = await unescapeNested(_files)

        let _s3Files = await getS3Files()

        let allFiles = [..._files, ..._s3Files]

        

        setFiles(allFiles)
        setLoading(false)
    }

    const getS3Files = () => {

        return new Promise((resolve, reject) => {

            let ref = reference
            try {
                ref = reference.replace('P', '')
            } catch {

            }

            let s3 = new AWS.S3({apiVersion: '2006-03-01'});
            var bucketParams = {
                Bucket  :   'pod.opex.co.uk',
                Prefix  :   `${ref}`
            };

            console.log('getting files for', ref)

            s3.listObjectsV2(bucketParams, async (err, data) => {
                if (err) {
    
                    reject(err)
    
                } else {
                    
                    let _s3Files = [];
        
                    let i = 1;
                    for await (let f of data.Contents) {

                        i++;
        
                        if (f.Key.indexOf(ref) > -1) {
        
                            let presignedURL = await s3.getSignedUrl('getObject', {
                                Bucket: 'pod.opex.co.uk',
                                Key: f.Key,
                                Expires: 60*5
                            })
        
                            _s3Files.push({
                                fileKey:        i,
                                fileLocation:   presignedURL,
                                username:       "Scanned",
                                created:        dayjs(f.LastModified).format('YYYY-MM-DD'),
                                description:    `Scanned document for booking ${reference}`
                            });
                        }
                    }
        
                    resolve(_s3Files)
    
                }
            });

            
        })

    }

    const cols = () => {

        return ([
            {
                title: 'Created',
                key: 'created',
                render: item => dayjs(item.created).format('DD/MM/YYYY')
            },
            {
                title: 'Description',
                render: item => item.description,
                key: 'description',
            },
            {
                title: '',
                key: 'actions',
                render: item => { return (
                    <div style={{textAlign: 'right'}}>
                        <Button onClick={() => window.open(item.fileLocation)} type="primary">View</Button>
                    </div>
                )}

            },
        ])
    }

    return (
        !loading ?
        <div>
            <div className="fCard">
                <Table dataSource={files} columns={cols()} rowKey={"podKey"} pagination={false} />
            </div>
        </div>
        : <Loader/>
    )
    
    

}
